import { useContext } from "react"
import { OtherContext } from "../provider/OtherProvider";

export interface OtherCompProps {
    address:string
}
export function OtherComp (props:OtherCompProps) {
    // 取到上下文中作为 context 的对象
    const otherContext = useContext(OtherContext);
    const info = otherContext.getInfo();
    return (<div>
            {info}
            <br/>
            {props.address}
        </div>)
}